<template>
  <section v-if="props.data.items" class="offerSlider defaultSectionPaddings defaultSectionMargins" :class="{'singleOffer': props.data.items.length === 1}">
    <div class="container">
      <h2 v-html="props.data.title" />

      <FlickitySlider class="offerSlider__Slider mediumArrows" :options="flickityOptions" :with-progress="true" :min-number-of-slides="3">
        <div v-for="item in props.data.items" class="offerSlider__Item">
          <div class="offerSlider__ImagesWrapper">
            <FlarePicture
              class="offerSlider__MainImage"
              :src="{
                1920: { src: item.offer.image, width: 550, height: 355, size: 'both', crop: 'fill' },
              }"
              :alt="item.offer.image"
            />

            <img v-if="item.offer.image_document_discount?.meta?.format === 'svg' && item.offer.image_document_discount.meta.url" class="offerSlider__DiscountImage" :src="item.offer.image_document_discount.meta.url" :alt="item.offer.image_document_discount.title || ''" width="250" height="150" />
          </div>
          <div class="offerSlider__Content">
            <div class="offerSlider__Dates">{{ formatDate(item.offer.travel_date_from) }} - {{ formatDate(item.offer.travel_date_to) }}</div>

            <div>
              <h3 v-text="item.offer.title" />
              <p v-text="item.offer.subtitle" />
            </div>
          </div>
          <nuxt-link :to="item.offer.sef">{{ item.offer.title }}</nuxt-link>
        </div>
      </FlickitySlider>
    </div>
  </section>
</template>

<script setup>

const props = defineProps({
  data: {}
});

const flickityOptions = {
  pageDots: false,
  contain: true,
  cellAlign: 'left',
};

console.log('OfferSlider data:', props.data);
</script>

<style lang="scss">
  @import url('@/assets/styles/components/blocks/_offerSlider.scss');
</style>